import { Button, Icon, Side, Switch, Tooltip } from "@focus/focusUI";
import { useCesium, type TLE } from "@focus/visual3D";
import { useState } from "react";
import type { CatalogueObject } from "../../types/catalog";

interface FocusedSpaceObject {
  id: string;
  type: "spaceObject";
  item: CatalogueObject;
}

interface Catalogue3DToolsProps {
  tles: TLE[];
}

export const Catalogue3DTools = ({ tles }: Catalogue3DToolsProps) => {
  const { viewer, isViewerLoaded } = useCesium();
  const [isSpaceObjectToolsVisible, setIsSpaceObjectToolsVisible] =
    useState(false);
  const [applyBasicFilter, setApplyBasicFilter] = useState<boolean>(false);



  return (
    <div className=" top-2 left-2 bp5-dark">
      <div className="flex gap-2">
        <Button
          data-testid={"testid-space-object-tools"}
          className="!px-1"
          icon={
            isSpaceObjectToolsVisible ? "cross" : <Icon icon="menu" size={20} />
          }
          large
          onClick={() =>
            setIsSpaceObjectToolsVisible(!isSpaceObjectToolsVisible)
          }
        />
      </div>
      <div className="max-h-[560px] 3xl:max-h-[650px] 4xl:max-h-[1200px] 5xl:max-h-[1800px] flex gap-4 items-start">
        <div className="w-[25rem] h-fit max-h-[inherit] overflow-y-auto scrollbar-none px-6 py-4 mt-2 bg-zinc-600/40 backdrop-blur-md rounded-[0.15rem] border border-gray-500">
          <div className="mb-2 flex gap-2 justify-between items-center">
            <h3 className="text-2xl text-center">Space Objects Filters</h3>
            <Button icon="cross" outlined text="Reset Scene" />
          </div>
          <div className="flex flex-col gap-2">
            <label className="p-1">Space Objects:</label>
            <div className="ps-2 flex justify-between items-center">
              <span>{`Selected ${10} space objects:`}</span>
              <Button icon="cross" outlined>
                Clear list
              </Button>
            </div>
            <div className="max-h-[6.5rem] 4xl:max-h-64 5xl:max-h-[32rem] px-1 overflow-y-auto flex flex-col gap-2">
              {tles.map((item, index) => (
                <div
                  key={index}
                  className="px-2 py-1 rounded bg-gray-600 flex gap-2 items-center"
                >
                  <span className="flex-1">{item.name}</span>
                  <Icon icon="cross" className="cursor-pointer" />
                </div>
              ))}
            </div>
          </div>
          <div className="flex gap-2 items-center">
            <Switch
              value={applyBasicFilter}
              onChange={() => setApplyBasicFilter(!applyBasicFilter)}
            />
            <span>Show only selected space objects</span>
          </div>
        </div>
      </div>
    </div>
  );
};
